

































import { Vue, Component, Prop } from 'vue-property-decorator'
import { OrganizationStep } from '@/classes/enums/OrganizationStep'
import Organization from '@/classes/Organization'
import Domain from '@/classes/Domain'
import HIVETextField from '@/components/common/HIVETextField.vue'
import HIVEButton from '@/components/common/HIVEButton.vue'
import CreateDomainRequest from '@/classes/request_objects/accounts/domains/CreateDomainRequest'
// import OrganizationLibraries from '../OrganizationLibraries.vue'
import PurchasedLibraries from '../PurchasedLibraries.vue'
// import PurchasedLibraryPermissions from '../PurchasedLibraryPermissions.vue'

@Component({
  components: {
    HIVETextField,
    HIVEButton,
    // OrganizationLibraries,
    PurchasedLibraries,
    // PurchasedLibraryPermissions
  },
})
export default class CreateUpdatePaidLibrariesForm extends Vue {
  @Prop(Boolean) public complete: boolean
  @Prop(Boolean) public isNewOrganization: boolean
  @Prop(Number) public step: number
  @Prop(Object) public organization: Organization

  // private SELL_TAB = 1
  // private PURCHASE_TAB = 2
  // private PERMISSIONS_TAB = 3
  // private tabNames: Array<string> = ['Sell', 'Purchase', 'Permissions']

  private get isComplete() {
    return this.complete
  }

  private get getOrganization() {
    return this.organization
  }

  private get getStepNumber() {
    return this.step
  }
}
